import { render, staticRenderFns } from "./UserEkspedisiTambah.vue?vue&type=template&id=63fcd8e8&scoped=true"
import script from "./UserEkspedisiTambah.vue?vue&type=script&lang=js"
export * from "./UserEkspedisiTambah.vue?vue&type=script&lang=js"
import style0 from "./UserEkspedisiTambah.vue?vue&type=style&index=0&id=63fcd8e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fcd8e8",
  null
  
)

export default component.exports